let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9HJjr")).then(() => parcelRequire('1ni2E'));